import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
// import Paper from '@material-ui/core/Paper';
// import Timeline from '../../components/TimeLine/TimeLine';
import Stepper from '../../components/Stepper/Stepper';
import Carousal from '../../components/Stepper/Carousal';
import Review from '../../components/common/RatingStars';
import {colors,fontFamily,fontSizes } from '../../styles/variables'

// import Typography from '@material-ui/core/Typography';

const clientreview = require('../../images/clientreview.png');
// const reviewflag = require('../../images/reviewflag.png');

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
        // paddingLeft:80,
       // paddingRight:80
      '@media only screen and (max-width: 959px)': {
        display:'flex',
        justifyContent:'center'
      },
    
    },
    root3: {
        flexGrow: 1,
        margin: 0,
        padding: 0,
        height: '100%',
        backgroundColor:colors.white
    },
    container:{
        margin:0,
        // marginLeft:'7em'
    },
    paper: {
        height: 350,
        width: 550,
        borderRadius:19,
        boxShadow:'0px 0px 40px #0C207219',
        paddingBottom:10,
        marginTop:50,
        '@media only screen and (max-width: 959px)': {
          marginLeft:'7%',
          marginBottom:'5%',
          width: '80%',
          height: '60%',
          // maxWidth: "62%",
        },
    },
    paperContainer:{
        display:'flex',
        justifyContent:'center',
        margin:0,
        '@media only screen and (max-width: 959px)': {
          display:'flex',
          justifyContent:'center',
          margin:0
        }
    },
    clientReviewImage:{
        width:480,
        justifyContent:'center',
        objectFit:'contain',
        marginBottom:12,
        '@media only screen and (max-width: 959px)': {
          width:'50%',
          display:'flex',
          justifyContent:'center',
          // maxWidth: "62%"
        },
    },
    clientReviewImageDiv:{
        display:'flex',
        paddingTop:80,
        paddingLeft:10,
        paddingBottom:30,
        justifyContent:'space-around',
        flexDirection:'row',
        alignContent:'space-around',
        '@media only screen and (max-width: 959px)': {
          alignContent:'center',
          justifyContent:'center',
          paddingLeft:0,
          //paddingLeft:'30vw',
          // maxWidth: "62%",
        },
        '@media only screen and (min-width: 1500px)': {
          alignContent:'center',
          justifyContent:'space-around',
          // paddingLeft:'7em',
          //paddingLeft:'30vw',
          // maxWidth: "62%",
        },
    },
    reviwFlagImage:{
        width:60,
        justifyContent:'center',
        objectFit:'contain'
    },
    reviwFlagImageDiv:{
        display:'flex',
        paddingTop:100,
        paddingBottom:10,
        justifyContent:'center',
        alignContent:'center',
    },
    Typography:{
        fontFamily:'Poppins',
        fontSize:'2rem',
        fontWeight:'bold',
        color:'black',
        textAlign:'left',
        paddingLeft:'16%',
        paddingTop:'15%',
        paddingBottom:'2%'
    },
    Typography2: {
        textAlign: 'center',
        justifyContent:'center',
        fontSize: 30,
        display:'flex',
        width:'75%',
        color:'black'
        // fontWeight: 300
    },
    reviewHeadingMain:{
        display:'flex',
        justifyContent:'center',
        paddingTop:90,
        // paddingLeft:'6em',
        //paddingRight:100,
        height:80,
        '@media only screen and (max-width: 959px)': {
          paddingTop:40,
          paddingRight:0,
          height:80,
          // paddingLeft:'2em',
        },
    },
    reviewHeading:{
        fontSize:fontSizes.md.large,
        fontWeight:'bold',
        textAlign:'center',
        color:'black',
        '@media only screen and (max-width: 700px)': {
          fontSize:fontSizes.md.regular,
        },
    },
    itemHeading:{
        fontFamily:fontFamily.poppins,
        fontSize:25,
        fontWeight:'normal',
        textAlign:'center',
        color:'black',
    },
    itemDescription:{
        fontFamily:fontFamily.poppins,
        fontSize:13,
        fontWeight:'lighter',
        textAlign:'center',
        color: colors.black,
        lineHeight: 2,
        paddingTop:60,
        paddingLeft:30,
        paddingRight:30,
        // overflow:'hidden',
        height:90
    },
    timeLine:{
        marginTop:60,
        '@media only screen and (max-width: 959px)': {
           display:'none'
        },
    },
    bottomTextMain:{
        // display:'flex',
        justifyContent:'center',
        textAlign:'center',
        alignItems:'center',
        alignContent:'cnter',
        marginBottom:80,
        // paddingRight:40,
        '@media only screen and (max-width: 959px)': {
           display:'flex',
           justifyContent:'center',
           textAlign:'center',
           flexDirection:'column',
           alignItems:'center',
           alignContent:'cnter',
           marginBottom:40,
           paddingRight:0,
        },
    },
    bottomText1:{
        fontFamily:fontFamily.poppins,
        color:'#ED5565',
        fontSize:50,
        fontWeight:'bold',
        '@media only screen and (max-width: 959px)': {
          fontSize:'2rem',
         },
    },
    bottomText2:{
        fontFamily:fontFamily.poppins,
        color:'black',
        fontSize: fontSizes.lg.regular,
        fontWeight:'bold',
        '@media only screen and (max-width: 959px)': {
          fontSize:'1.5rem',
         },
    },
    rating:{
        justifyContent:'center',
        alignItems:'center',
        paddingRight:70,
        '&.MuiRating-sizeLarge':{
            fontSize:'2.875rem',
        }
    }
  }),
);

export default function ClientReview() {
  const classes = useStyles();
  return (
     <div className={classes.root3}>
       <Grid container className={classes.root}>
         <Grid item md={5} sm={12}>
             <Grid  spacing={0} className={classes.container}>
               <Grid item spacing={2}>
                  <div className={classes.clientReviewImageDiv}>
                    <img src={clientreview} alt="clientreview" className={classes.clientReviewImage}/>
                  {/* 
                  
                   <div  className={classes.timeLine}>
                      <Timeline/>
                    </div>
                  */} 
                  </div>
               </Grid>
               
             </Grid>
             <div className={classes.bottomTextMain}>
               <div className={classes.bottomText1}>200,000</div>
               <div className={classes.bottomText2}>Successful recordings<br/>every month</div>
             </div>
         </Grid>
           <Grid item md={7} sm={12}>
             <Grid spacing={0} className={classes.container}>
                <div className={classes.reviewHeadingMain}>
                    <div className={classes.reviewHeading}>Loved by Millions</div>
                </div>
                {/* 
                 <Grid item spacing={2} className={classes.paperContainer}>
                     <Paper className={classes.paper}>
                        <div className={classes.itemDescription}>“love it, always wonderful site…. USE THIS SITE FOR SCREEN RECORDING PEOPLE PEOPLE!!!!!!!! “</div>
                        <div className={classes.reviwFlagImageDiv}>
                           <img src={reviewflag} alt="featuresimage" className={classes.reviwFlagImage}/>
                        </div>
                        <div className={classes.itemHeading}>Mathew J</div>
                     </Paper>
                 </Grid>
                
                */}
                <Carousal/>
               {/* <Stepper/>  */} 
                 <Review/>
              </Grid>
           </Grid>
       </Grid>
     </div>
  );
}
